<template>
  <v-app>  
    <v-container fluid pa-0>
      <main>
        <Header />
        <router-view />
      </main>
    </v-container>
  </v-app>  
</template>

<script>
import Header from '@/components/Header.vue'

export default {
  components: {
    Header
  },
};
</script>
